import SearchDropdown from "../../../../components/UI/PageInput/SearchDropdown";
import MultipleChecks from "./MultipleChecks";
import DateInput from "../../../../components/UI/PageInput/DateInput";

const CompanyInfo = ({
  userSetup,
  errors,
  setValue,
  control,
  watch,
  render,
  register,
}) => {
  const {
    roles,
    jbcc_supervisor_id,
    jbcc_admin_id,
    jn_supervisor_id,
    jn_admin_id,
    date_of_joining,
  } = watch();
  return (
    <div className="pr-1">
      <div className="userInfoWrap">
        <h4 className="userInfoHeading">Company Info</h4>
        <div className="flex gap-3 p-4">
          <div className="w-full">
            {" "}
            <DateInput
              label="Date of Joining *"
              name={"date_of_joining"}
              value={date_of_joining}
              setValue={setValue}
              register={{
                ...register("date_of_joining", {
                  required: "Please Select date of birth",
                }),
              }}
              error={errors.date_of_joining}
              disableCurrentAndFutureDays={true}
            />
            <SearchDropdown
              name="jbcc_supervisor_id"
              label="Supervisor (JBCC) *"
              keyName="fullName"
              id="id"
              options={userSetup.jbccSupervisors}
              control={control}
              setValue={setValue}
              selectedVal={jbcc_supervisor_id}
              error={errors.jbcc_supervisor_id}
              render={render}
            />
            <SearchDropdown
              name="jbcc_admin_id"
              label="Admin (JBCC) *"
              keyName="fullName"
              id="id"
              options={userSetup.jbccAdmins}
              control={control}
              setValue={setValue}
              selectedVal={jbcc_admin_id}
              error={errors.jbcc_admin_id}
              render={render}
            />
          </div>
          <div className="w-full">
            <MultipleChecks
              name="roles"
              options={userSetup.roles}
              error={errors.roles}
              roles={roles}
              control={control}
            />
            <SearchDropdown
              name="jn_supervisor_id"
              label="Supervisor (Jal Nirikshan) *"
              keyName="fullName"
              id="id"
              options={userSetup.jnSupervisors}
              control={control}
              setValue={setValue}
              selectedVal={jn_supervisor_id}
              error={errors.jn_supervisor_id}
              render={render}
            />
            <SearchDropdown
              name="jn_admin_id"
              label="Admin (Jal Nirikshan) *"
              keyName="fullName"
              id="id"
              options={userSetup.jnAdmins}
              control={control}
              setValue={setValue}
              selectedVal={jn_admin_id}
              error={errors.jn_admin_id}
              render={render}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default CompanyInfo;
